/* eslint-disable @typescript-eslint/no-non-null-assertion */
import CreatedIframe from '@/mixins/create-iframe';
import { Popup } from 'vant';
import {
  Component, Mixins, Model, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { VueClass } from 'vue-class-component/lib/declarations';

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');

@Component({
  name: 'ZiyingBPopup',
})
export default class ZiyingBPopup extends Mixins(CreatedIframe) {
  @Model('change', {
    type: Boolean,
  })
  isVisiblePopup!: boolean;

  /**
     * 协议链接，供 iframe 展示
    */
  @Prop(String)
  private rightsUrl!: string;


  /**
     * 弹窗标题
    */
  @Prop(String)
  private popupTitle!: string;

  /**
     * 弹窗样式，是否全屏，无标题，只显示右边关闭按钮
    */
  @Prop({
    type: Boolean,
    default: false,
  })
  private fullScreen!: boolean;


  @Prop({
    type: Boolean,
    default: false,
  })
  private showUnopenedDetailUrl!: boolean;

  // #45311A

  @ApplyProductStore.Action $updateState!: (data: Dictionary) => void;

  /** 本地合同需要渲染的地方 */
  private clazz: VueClass<Vue> | undefined = undefined;

  @Watch('isVisiblePopup')
  private onChangeProps(val: boolean) {
    if (val) {
      this.$nextTick(() => {
        // const ele = document.getElementById('currentDom_rights')!;
        // ele.addEventListener('scroll', () => {
        //   this.currentScrollHeight = ele.scrollTop;
        // }, { passive: true });
        this.showType();
      });
    } else {
      const ele = document.getElementById('currentDom_rights')!;
      ele.scrollTo(0, 0);
    }
  }

  /**
   * iframe嵌入文件展示
   */
  private showType() {
    this.createdIframe(
      this.rightsUrl,
      'currentIframe_right',
      'fatherIframe_right',
      this.showUnopenedDetailUrl ? style.channelStyle as string : (
        (this.$scopedSlots.header || this.$slots.header) ? style.iframeNotop : style.iframeStyle
      ) as string,
    );
    this.createListener();
  }

  // 关闭
  private onClosedPopup() {
    this.$emit('close');
  }

  private showContractName(name: string): string {
    if (!name) return '';
    return name.includes('《') ? name.replace('《', '').replace('》', '') : name;
  }

  private createListener() {
    const iframeDom = document.getElementById('currentIframe_right') as HTMLIFrameElement | null;
    if (iframeDom) {
      iframeDom.onload = () => {
        try {
        // 类型守卫验证
          if (!(iframeDom.contentDocument || iframeDom.contentWindow)) {
            throw new Error('无法访问iframe文档');
          }

          const iframeDoc = iframeDom.contentDocument
          || (iframeDom.contentWindow && iframeDom.contentWindow.document);

          if (!iframeDoc) {
            throw new Error('iframe文档未定义');
          }

          iframeDoc.addEventListener('click', (event) => {
            // 添加类型守卫验证
            if (event.target) {
              const targetId = (event.target as HTMLElement).getAttribute('id');
              if (targetId === 'rulerButton') {
                this.$emit('changeClose', false);
              } else if (targetId === 'rulerButtonClose') {
                this.$emit('changeClose', true);
              }
            }
          });
        } catch (error) {
          throw new Error('iframe访问失败');
        }
      };
    }
  }

  private render() {
    // 提前计算 header 部分的内容
    // 优先使用 scopedSlots，如果没有则使用普通 slots
    const headerContent = (this.$scopedSlots.header && this.$scopedSlots.header({}))
      || this.$slots.header
      || (
      <div class={style.title}>
        <span>{this.showContractName(this.popupTitle)}</span>
        <span class={style.closed} onClick={this.onClosedPopup.bind(this)}></span>
      </div>
      );

    return (
      <div class={style.ZiyingBPopup}>
        <Popup
          v-model={this.isVisiblePopup}
          class={style.popupRadius}
          position='bottom'
          closeOnClickOverlay={false}
        >
          <section class={style.mainContent}>
            <div class={style.navContent}>
              {this.fullScreen ? (
                <span class={style.closedFullScreen} onClick={this.onClosedPopup.bind(this)}></span>
              ) : (headerContent)}

              <div class={style.contractPart} id={'currentDom_rights'}>
              <div class={style.contentScroll}>
                <div class={style.contentBar}>
                  <div id='fatherIframe_right' class={[style.iframeContent, this.fullScreen ? style.fullscreenIframe : '']}>
                  </div>
                </div>

                </div>

              </div>
            </div>
          </section>
        </Popup>
      </div>
    );
  }
}
